// The dice bag's Private choice (decision 1; issue 1158): one setting for the DM's throws, read by the dice bag and by
// the Tables panel, so a table rolled from either follows the same switch. Private by default, as the DM's rolls are;
// held for the page's life, never stored.
import { useSyncExternalStore } from 'react';

let priv = true;
const listeners = new Set<() => void>();

export const dicePrivate = (): boolean => priv;
export function setDicePrivate(next: boolean): void {
  if (next === priv) return;
  priv = next;
  for (const l of listeners) l();
}
const subscribe = (l: () => void) => { listeners.add(l); return () => { listeners.delete(l); }; };

/** The choice and its setter, as a React state pair. */
export function useDicePrivate(): [boolean, (next: boolean) => void] {
  return [useSyncExternalStore(subscribe, dicePrivate, dicePrivate), setDicePrivate];
}
